import { useEffect, useMemo, useState } from 'react';

import moment from 'moment';

import ChartUniversal from './chart/ChartUniversal';
import Loading from './Loading';
import UniversalTable from './table/UniversalTable';
import { useActions } from '../../../../hooks/useActions';
import { useTypedSelector } from '../../../../hooks/useTypedSelector';
import TypeIcon from '../../params/attribution/icons/TypeIcon';
import Params from '../../params/Params';

const detailsItems = [
    { name: 'по дням', value: 'd' },
    { name: 'по неделям', value: 'w' },
    { name: 'по месяцам', value: 'm' },
    { name: 'по кварталам', value: 'q' },
    { name: 'по годам', value: 'y' },
];

const filtersFilter = [
    'Пользователи',
    'Регистрации',
    'Заявки',
    'Заказы',
    'Платежи',
    'Вебинары',
    'Реклама',
];
const attributionItems = [
    {
        id: 'type_applications',
        name: 'Тип регистрации:',
        selectValues: [
            { name: 'Нулевые заказы GC', id: '2', icon: null },
            { name: 'Регистрации GC', id: '0', icon: null },
            { name: 'SCAN', id: '1', icon: null },
            //{ name: "Ручное добавление", id: "3", icon: null },
        ],
        description: `Выбор типа регистрации по которым нужно создать отчёт:
                    <br><br>
                    Типы регистраци:
                    <br><br>
                    - SCAN - Это данные собираемые скриптом SCAN с форм;<br>
                    - Нулевые заказы GC - Заказы в GetCourse со стоимостью 0 руб.;<br>
                    - Регистрации GC -  Первая регистрация (попадания в базу) в GetCourse;<br>
                    <br><br>
                    <a href="https://doc.scananalytics.ru/otchety/tip-registracii/" rel="noopener noreferrer" target="_blank">Подробнее</a>.
                `,
        icon: <TypeIcon />,
    },
];

const CogApp = () => {
    const { filters } = useTypedSelector((state) => state.filter);
    const { attributes } = useTypedSelector((state) => state.attributes);
    const [ loadingTable, setLoadingTable ] = useState(false);
    const { setFilters ,setFilterParent, setAttributes, setPeriod } = useActions();

    useEffect(() => {
        setPeriod({
            start: moment(new Date().toUTCString()),
            end: moment(new Date().toUTCString()),
            interval: 'last30days',
            select: 'last30days',
        });
        setAttributes({ attribution: [ '1' ], type_applications: [ '0' ] });
        setFilters([]);
        setFilterParent([]);
    }, []);

    const tableMemo = useMemo(() => (
    <UniversalTable
        filters={filters}
        filtersReq={attributes}
        loadingChart={false} /*загрузка графика не отслеживается*/
        loadingTable={false}
        setLoadingTable={setLoadingTable}
    />), [ attributes, filters ]);
    return (
    <div>
      <Loading loading={loadingTable} hasTip={false}>
        <Params
            withCompare={false}
            withAttribution={true}
            detailsItems={detailsItems}
            filtersFilter={filtersFilter}
            attributionItems={attributionItems}
            defaultPeriod={'last30days'}
        />

      {/*<ErrorBoundary>*/}
      <ChartUniversal loadingChart={false} />
      {/*</ErrorBoundary>*/}

      {/*<ErrorBoundary>*/}
      {tableMemo}
      {/*</ErrorBoundary>*/}
      </Loading>
    </div>
    );
};

export default CogApp;
